var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.714,
    height: 42.3,
    viewBox: "0 0 42.714 42.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon5",
    transform: "translate(-6.225 -6.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3507",
    "data-name": "Grupo 3507",
    transform: "translate(6.375 6.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11033",
    "data-name": "Caminho 11033",
    d: "M26.56,27.388H12.078a.828.828,0,0,1-.828-.828V12.078a.828.828,0,0,1,.828-.828H26.56a.828.828,0,0,1,.828.828V26.56A.828.828,0,0,1,26.56,27.388ZM12.905,25.733H25.733V12.905H12.905Z",
    transform: "translate(-7.216 -7.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11033_-_Contorno",
    "data-name": "Caminho 11033 - Contorno",
    d: "M26.56,27.538H12.078a.979.979,0,0,1-.978-.978V12.078a.979.979,0,0,1,.978-.978H26.56a.979.979,0,0,1,.978.978V26.56A.979.979,0,0,1,26.56,27.538ZM12.078,11.4a.678.678,0,0,0-.678.678V26.56a.678.678,0,0,0,.678.678H26.56a.678.678,0,0,0,.678-.678V12.078a.678.678,0,0,0-.678-.678ZM25.883,25.883H12.755V12.755H25.883Zm-12.828-.3H25.583V13.055H13.055Z",
    transform: "translate(-7.216 -7.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11034",
    "data-name": "Caminho 11034",
    d: "M48.56,27.388H34.078a.828.828,0,0,1-.828-.828V12.078a.828.828,0,0,1,.828-.828H48.56a.828.828,0,0,1,.828.828V26.56A.828.828,0,0,1,48.56,27.388ZM34.905,25.733H47.733V12.905H34.905Z",
    transform: "translate(-11.009 -7.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11034_-_Contorno",
    "data-name": "Caminho 11034 - Contorno",
    d: "M48.56,27.538H34.078a.979.979,0,0,1-.978-.978V12.078a.979.979,0,0,1,.978-.978H48.56a.979.979,0,0,1,.978.978V26.56A.979.979,0,0,1,48.56,27.538ZM34.078,11.4a.678.678,0,0,0-.678.678V26.56a.678.678,0,0,0,.678.678H48.56a.678.678,0,0,0,.678-.678V12.078a.678.678,0,0,0-.678-.678ZM47.883,25.883H34.755V12.755H47.883Zm-12.828-.3H47.583V13.055H35.055Z",
    transform: "translate(-11.009 -7.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11035",
    "data-name": "Caminho 11035",
    d: "M26.56,49.388H12.078a.828.828,0,0,1-.828-.828V34.078a.828.828,0,0,1,.828-.828H26.56a.828.828,0,0,1,.828.828V48.56A.828.828,0,0,1,26.56,49.388ZM12.905,47.733H25.733V34.905H12.905Z",
    transform: "translate(-7.216 -11.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11035_-_Contorno",
    "data-name": "Caminho 11035 - Contorno",
    d: "M26.56,49.538H12.078a.979.979,0,0,1-.978-.978V34.078a.979.979,0,0,1,.978-.978H26.56a.979.979,0,0,1,.978.978V48.56A.979.979,0,0,1,26.56,49.538ZM12.078,33.4a.678.678,0,0,0-.678.678V48.56a.678.678,0,0,0,.678.678H26.56a.678.678,0,0,0,.678-.678V34.078a.678.678,0,0,0-.678-.678ZM25.883,47.883H12.755V34.755H25.883Zm-12.828-.3H25.583V35.055H13.055Z",
    transform: "translate(-7.216 -11.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11036",
    "data-name": "Caminho 11036",
    d: "M48.56,49.388H34.078a.828.828,0,0,1-.828-.828V34.078a.828.828,0,0,1,.828-.828H48.56a.828.828,0,0,1,.828.828V48.56A.828.828,0,0,1,48.56,49.388ZM34.905,47.733H47.733V34.905H34.905Z",
    transform: "translate(-11.009 -11.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11036_-_Contorno",
    "data-name": "Caminho 11036 - Contorno",
    d: "M48.56,49.538H34.078a.979.979,0,0,1-.978-.978V34.078a.979.979,0,0,1,.978-.978H48.56a.979.979,0,0,1,.978.978V48.56A.979.979,0,0,1,48.56,49.538ZM34.078,33.4a.678.678,0,0,0-.678.678V48.56a.678.678,0,0,0,.678.678H48.56a.678.678,0,0,0,.678-.678V34.078a.678.678,0,0,0-.678-.678ZM47.883,47.883H34.755V34.755H47.883Zm-12.828-.3H47.583V35.055H35.055Z",
    transform: "translate(-11.009 -11.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11037",
    "data-name": "Caminho 11037",
    d: "M47.961,48.625H7.2a.828.828,0,0,1-.828-.828V7.453A.828.828,0,0,1,7.2,6.625H47.961a.828.828,0,0,1,.828.828V47.8A.828.828,0,0,1,47.961,48.625ZM8.03,46.97h39.1V8.28H8.03Z",
    transform: "translate(-6.375 -6.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11037_-_Contorno",
    "data-name": "Caminho 11037 - Contorno",
    d: "M47.961,48.775H7.2a.979.979,0,0,1-.978-.978V7.453A.979.979,0,0,1,7.2,6.475H47.961a.979.979,0,0,1,.978.978V47.8A.979.979,0,0,1,47.961,48.775ZM7.2,6.775a.678.678,0,0,0-.678.678V47.8a.678.678,0,0,0,.678.678H47.961a.678.678,0,0,0,.678-.678V7.453a.678.678,0,0,0-.678-.678ZM47.284,47.12H7.88V8.13h39.4Zm-39.1-.3h38.8V8.43H8.18Z",
    transform: "translate(-6.375 -6.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11038",
    "data-name": "Caminho 11038",
    d: "M15.578,21.391a.827.827,0,0,1-.517-1.473l2.586-2.069a.827.827,0,0,1,1.034,1.292L16.094,21.21A.824.824,0,0,1,15.578,21.391Z",
    transform: "translate(-7.819 -8.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11038_-_Contorno",
    "data-name": "Caminho 11038 - Contorno",
    d: "M15.578,21.541a.977.977,0,0,1-.611-1.74l2.586-2.069a.978.978,0,0,1,1.374.152.977.977,0,0,1-.153,1.374l-2.586,2.069A.968.968,0,0,1,15.578,21.541Zm2.585-3.723a.671.671,0,0,0-.423.148l-2.586,2.069A.677.677,0,0,0,16,21.093l2.586-2.069a.677.677,0,0,0-.423-1.206Z",
    transform: "translate(-7.819 -8.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11039",
    "data-name": "Caminho 11039",
    d: "M19.287,23.182a.827.827,0,0,1-.517-1.473l2.586-2.069a.827.827,0,0,1,1.034,1.292L19.8,23A.821.821,0,0,1,19.287,23.182Z",
    transform: "translate(-8.458 -8.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11039_-_Contorno",
    "data-name": "Caminho 11039 - Contorno",
    d: "M19.287,23.332a.977.977,0,0,1-.611-1.74l2.586-2.069a.977.977,0,0,1,1.582.872.969.969,0,0,1-.361.655L19.9,23.118A.977.977,0,0,1,19.287,23.332Zm2.585-3.723a.67.67,0,0,0-.423.148l-2.586,2.069a.677.677,0,0,0,.846,1.058L22.3,20.815a.677.677,0,0,0-.424-1.206Z",
    transform: "translate(-8.458 -8.838)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.b5d2dff683e3553608e2677f227546c9.svg";
export { ForwardRef as ReactComponent };